function mapUserProfileType(type) {
  switch (type) {
    case '2':
      return 'teacher';
    case '3':
      return 'admin';
    default:
      return 'unknown';
  }
}

// Falls back to username as the distinct id when userProfileId is absent (dev).
export default function buildIdentityProps(params, locale) {
  return {
    locale,
    countryCode: params.countryCode || '',
    userProfileId: params.userProfileId || params.username || '',
    userProfileType: mapUserProfileType(params.userProfileType || ''),
    marketRegionId: params.marketRegionId || params.regionId || '',
    schoolId: params.schoolId || '',
    oneRosterUserId: params.oneRosterUserId || ''
  };
}



// WEBPACK FOOTER //
// ./analytics/identity/identity.js